// Libs
import React, { useEffect, useState } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
// Own Libs
import * as ui from '@digital/ui';
import { solicitacaoIdState } from '../atoms';
import { useRecoilValue } from 'recoil';
import { HistoricoSolicitacaoNaoPrevisto, getHistoricoSolicitacaoNaoPrevisto } from '@app/api/naoPrevistos/solicitacao';

const columnsHistorico = [
    {
        title: 'Responsável',
        dataIndex: 'usuarioResponsavel',
        key: 'usuarioResponsavel',
        width: '15%',
    },
    {
        title: 'Descrição',
        dataIndex: 'descricao',
        key: 'descricao',
    },
    {
        title: 'Data / Hora',
        dataIndex: 'dataHoraFormatada',
        key: 'dataHoraFormatada',
        width: '15%',
    },
];

const AbaHistorico = () => {
    const id = useRecoilValue(solicitacaoIdState);
    const [data, setData] = useState<HistoricoSolicitacaoNaoPrevisto[]>([]);

    useEffect(() => {
        if (id) {
            getHistoricoSolicitacaoNaoPrevisto(id).then((result) => {
                if (result) {
                    setData(result);
                }
            })
        }
    }, [id]);

    return (
        <PerfectScrollbar>
            <ui.Widget>
                <ui.Row>
                    <ui.Table
                        columns={columnsHistorico}
                        rowKey="index"
                        dataSource={data}
                        pagination={false} />
                </ui.Row>
            </ui.Widget>
        </PerfectScrollbar>
    );
};
export default AbaHistorico;